const countries = [
	{ id: 1, dial_code: "+93", country_code: "AFG", name: "Afghanistan" },
	{ id: 2, dial_code: "+355", country_code: "ALB", name: "Albania" },
	{ id: 3, dial_code: "+213", country_code: "DZA", name: "Algeria" },
	{ id: 4, dial_code: "+376", country_code: "AND", name: "Andorra" },
	{ id: 5, dial_code: "+244", country_code: "AGO", name: "Angola" },
	{ id: 6, dial_code: "+54", country_code: "ARG", name: "Argentina" },
	{ id: 7, dial_code: "+61", country_code: "AUS", name: "Australia" },
	{ id: 8, dial_code: "+43", country_code: "AUT", name: "Austria" },
	{ id: 9, dial_code: "+973", country_code: "BHR", name: "Bahrain" },
	{ id: 10, dial_code: "+880", country_code: "BGD", name: "Bangladesh" },
	{ id: 11, dial_code: "+32", country_code: "BEL", name: "Belgium" },
	{ id: 12, dial_code: "+55", country_code: "BRA", name: "Brazil" },
	{ id: 13, dial_code: "+1", country_code: "CAN", name: "Canada" },
	{ id: 14, dial_code: "+86", country_code: "CHN", name: "China" },
	{ id: 15, dial_code: "+357", country_code: "CYP", name: "Cyprus" },
	{ id: 16, dial_code: "+20", country_code: "EGY", name: "Egypt" },
	{ id: 17, dial_code: "+33", country_code: "FRA", name: "France" },
	{ id: 18, dial_code: "+49", country_code: "DEU", name: "Germany" },
	{ id: 19, dial_code: "+91", country_code: "IND", name: "India" },
	{ id: 20, dial_code: "+62", country_code: "IDN", name: "Indonesia" },
	{ id: 21, dial_code: "+81", country_code: "JPN", name: "Japan" },
	{ id: 22, dial_code: "+960", country_code: "MDV", name: "Maldives" },
	{ id: 23, dial_code: "+52", country_code: "MEX", name: "Mexico" },
	{ id: 24, dial_code: "+234", country_code: "NGA", name: "Nigeria" },
	{ id: 25, dial_code: "+47", country_code: "NOR", name: "Norway" },
	{ id: 26, dial_code: "+92", country_code: "PAK", name: "Pakistan" },
	{ id: 27, dial_code: "+63", country_code: "PHL", name: "Philippines" },
	{ id: 28, dial_code: "+7", country_code: "RUS", name: "Russia" },
	{ id: 29, dial_code: "+27", country_code: "ZAF", name: "South Africa" },
	{ id: 30, dial_code: "+82", country_code: "KOR", name: "South Korea" },
	{ id: 31, dial_code: "+34", country_code: "ESP", name: "Spain" },
	{ id: 32, dial_code: "+41", country_code: "CHE", name: "Switzerland" },
	{ id: 33, dial_code: "+90", country_code: "TUR", name: "Turkey" },
	{ id: 34, dial_code: "+44", country_code: "GBR", name: "United Kingdom" },
	{ id: 35, dial_code: "+1", country_code: "USA", name: "United States" },
];

export default countries;
